import React from 'react';
import Fuse from 'fuse.js';
const useFuseSearch = <T>(query: string = '', items: T[], keys: string[]) => {
    const options = React.useMemo(
        () => ({
            location: 0,
            threshold: 0.3,
            distance: 100,
            keys: keys,
        }),
        [keys],
    );

    const filteredData = React.useMemo(() => {
        const fuse = new Fuse(items, options);
        const response = fuse.search(query);
        const _data = response?.map(({ item }) => item) as T[];

        if (query?.length > 0) {
            return _data;
        } else {
            return items;
        }
    }, [items, options, query]);

    if (!query || query.length === 0) return items;

    return filteredData;
};

export default useFuseSearch;
